import { ActivityType } from "./activity-type.constants";

export const ClockActivityText = {
	[ActivityType.ClockIn]: "Clocked in",
	[ActivityType.ClockOut]: "Clocked out",
	[ActivityType.Meal]: "Meal break",
	[ActivityType.Rest]: "Rest break",
};